import React from 'react';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import parseText from '../../utils/parseText';
import {Helmet} from 'react-helmet';
import MainContainer from '../../components/MainContainer';
import LayoutContainer from '../../components/LayoutContainer';
import Logo from '../../components/Logo';
import DisplayIban from '../../components/DisplayIban';
import Box from '../../components/Box';
import SocialShare from '../../components/SocialShare';
import {getFormData} from '@nexios/frontend-forms';
import {withTheme} from 'styled-components';
import DJSBSideBar from '../../components/DJSBSideBar';
import ThankYouAskForm from '../../components/ThankYouAskForm';
import Title from '../../components/Title';
import ProgressBar from '../../components/ProgressBar';

const getThankYouTexts = (formContext, formData, themeName) => {
  const showDonationFields = formData.showDonationFields;
  const isOneOff = formData.frequency === 'oneOff';
  const isDirectDebit = formData.paymentMethod === 'directDebit';

  let titleTemplate;
  let textTemplate;

  if (showDonationFields) {
    if (isOneOff) {
      if (isDirectDebit) {
        titleTemplate = formContext.oneOffThankYouTitle;
        textTemplate = formContext.oneOffThankYouTextHtml_txt;
      } else {
        titleTemplate = formContext.donationThankYouTitle;
        textTemplate = formContext.donationThankYouTextHtml_txt;
      }
    } else if (formContext.mandateType === 'temporary') {
      titleTemplate = formContext.temporaryThankYouTitle;
      textTemplate = formContext.temporaryThankYouTextHtml_txt;
    } else {
      titleTemplate = formContext.continuousThankYouTitle;
      textTemplate = formContext.continuousThankYouTextHtml_txt;
    }
  } else {
    titleTemplate = formContext.petitionThankYouTitle;
    textTemplate = formContext.petitionThankYouTextHtml_txt;
  }

  return [parseText(formData, titleTemplate), parseText({...formData, ...formContext}, textTemplate, themeName)];
};

const getAskConfig = (formData, formContext) => {
  const showDonationFields = formData.showDonationFields;
  const isOneOff = formData.frequency === 'oneOff';
  const alreadyAsked = formData.isThankYouAsk;

  if (!showDonationFields || (alreadyAsked && isOneOff)) {
    return {askConfig: formContext.thankYouAskOneOffConfig, askType: 'oneOff'};
  }
  if (isOneOff || alreadyAsked) {
    return {askConfig: formContext.thankYouAskRecurringConfig, askType: 'recurring'};
  }
  return {};
};

const Petition2 = ({formContext, formData, themeName, theme, progressBar}) => {
  const [thankYouTitle, thankYouText] = getThankYouTexts(formContext, formData, themeName);
  const {askConfig, askType} = getAskConfig(formData, formContext);

  return <>
    <Helmet>
      <title>{formContext.thankYouBrowserTitle}</title>
    </Helmet>
    <MainContainer
      backgroundImageUrl={formContext.backgroundImageUrl}
      backgroundImageTabletUrl={formContext.backgroundImageTabletUrl}
      backgroundImageMobileUrl={formContext.backgroundImageMobileUrl}
    />
    <LayoutContainer
      position={formContext.textPosition}
      header={<div>
        <div style={{float: 'left', display: 'inline-block'}}>
          <Logo url={formContext.websiteUrl} />
        </div>
        <DisplayIban iban='NL08 INGB 0000 0005 55' />
      </div>}
      content={<>
        <ThankYouAskForm askType={askType} config={askConfig} progressBar={progressBar}>
          <Box>
            {theme?.title?.showOnThankYou && <Title title={formContext.step4Header}><ProgressBar progress={progressBar} /></Title>}
            <div className='widgetContent'>
              <h1>{thankYouTitle}</h1>
              <div className='field'>
                <div dangerouslySetInnerHTML={{__html: thankYouText}} />
              </div>

              <SocialShare formContext={formContext} />
            </div>
          </Box>
        </ThankYouAskForm>
        {formContext.allowCallToAction &&
          <div dangerouslySetInnerHTML={{__html: formContext.callToAction}} />}
      </>}
      sidebar={<>
        {theme?.djsb?.showDJSB && <DJSBSideBar formContext={formContext}/>}
      </>}
      footer={formContext.footer}
      formContext={formContext}
    />
  </>;
};

const mapStateToProps = (state) => {
  return {
    formContext: state.reducer.formContext,
    formData: getFormData(state, 'donate'),
    themeName: state.reducer.theme
  };
};

export default connect(mapStateToProps)(withRouter(withTheme(Petition2)));

